import Vue from 'vue';
import {login,getUserInfo,signUpData} from '@/api/login'
import {ACCESS_TOKEN} from '@/store/mutation-types'

const user = {
    state :{
        token:'',
        name:'',
        avatar:'',
        info:'',
        role:[]
    },
    mutations:{
        SET_TOKEN:(state,token) => {
            state.token = token;
        },
        SET_NAME:(state,name) => {
            state.name = name;
        },
        SET_AVATAR:(state,avatar) => {
            state.avatar = avatar;
        },
        SET_INFO:(state,info) => {
            state.info = info;
        },
        SET_ROLE:(state,role) => {
            state.role = role
        }
    },
    actions:{
        //登入
        Login({commit},userInfo){
            return new Promise((resolve,reject) => {
                login(userInfo).then(response => {
                    const result = response;
                    Vue.ls.set(ACCESS_TOKEN, result.data, 24 * 60 * 60 * 1000)//存入token 24小时
                    commit('SET_TOKEN', result.data)
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        GetInfo({commit},data){
            return new Promise((resolve,reject) => {
                getUserInfo(data).then(response =>{
                    const result = response.data;
                    commit('SET_NAME',result.user_name);
                    commit('SET_INFO',result);
                    commit('SET_ROLE',result.power);
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        },
        Logout({commit,state}){
            return new Promise((resolve) =>{
                commit('SET_TOKEN', '')
                commit('SET_INFO','');
                commit('SET_ROLE', [])
                Vue.ls.remove(ACCESS_TOKEN)
                resolve();
            })
        },
        Signup({commit},userInfo){
            return new Promise((resolve,reject) => {
                signUpData(userInfo).then(response => {
                    // const result = response.data;
                    resolve(response)
                }).catch(error => {
                    reject(error)
                })
            })
        }
    }
}

export default user